import * as tslib_1 from "tslib";
import { Transform, Type } from 'class-transformer';
import { dateJSONTransformer } from '../../_constants/validation-format-constants';
import { BaseParameterDto } from '../../_models/base-parameter-dto';
const ɵ0 = () => Date, ɵ1 = () => Date;
export class AccApplicationParameterDto extends BaseParameterDto {
    getQueryString() {
        const tokens = [];
        if (!!this.communityId) {
            tokens.push(`communityId=${this.communityId}`);
        }
        if (!!this.customerId) {
            tokens.push(`customerId=${this.customerId}`);
        }
        if (!!this.startDate) {
            tokens.push(`startDate=${dateJSONTransformer(this.startDate)}`);
        }
        if (!!this.endDate) {
            tokens.push(`endDate=${dateJSONTransformer(this.endDate)}`);
        }
        tokens.push(`filterOption=${this.filterOption}`);
        tokens.push(`clearCache=${this.clearCache}`);
        return `?${tokens.join('&')}`;
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    Transform(dateJSONTransformer, { toPlainOnly: true }),
    tslib_1.__metadata("design:type", Date)
], AccApplicationParameterDto.prototype, "startDate", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    Transform(dateJSONTransformer, { toPlainOnly: true }),
    tslib_1.__metadata("design:type", Date)
], AccApplicationParameterDto.prototype, "endDate", void 0);
export { ɵ0, ɵ1 };
